import { Outlet } from 'react-router-dom';
import { Topbar } from './Topbar.js';
import { Sidebar } from './Sidebar.js';
import { Toaster } from './Toaster.js';

export function Layout(): JSX.Element {
  return (
    <div className="flex h-full flex-col">
      <Topbar />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <main className="flex-1 overflow-auto p-6">
          <Outlet />
        </main>
      </div>
      <Toaster />
    </div>
  );
}
